module.exports = __webpack_public_path__ + "img/warcraft3.f744c133.jpg";